<!-- TEMPLATE -->
<template>
  <dean-dialog
          class="graph"
          title="Groei in klanten"
          :icon="groupIcon"
          align-top>
    <div class="">
      <line-chart :data="source"></line-chart>
    </div>
    <transition name="fade" mode="out-in" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </dean-dialog>
</template>
<!-- SCRIPT -->
<script lang="ts">

  import axios from 'axios';
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import Chartkick from 'vue-chartkick';
  import Chart from 'chart.js';

  // DEAN COMPONENTS
  import {
    plusIcon,
    groupIcon,
    dashboardIcon,
    deanDialog,
    deanButton,
    deanLoadOverlay,
  } from '@deanone/dean-components';

  Vue.use(Chartkick.use(Chart));

  @Component({
    components: {
      deanLoadOverlay,
      Chartkick,
      Chart,
      plusIcon,
      groupIcon,
      dashboardIcon,
      deanDialog,
      deanButton,
    },
  })

  export default class CustomerGrowthWidget extends Vue {
    public plusIcon: object = plusIcon;
    public groupIcon: object = groupIcon;
    public source: object = {};
    public isLoading: boolean = true;

    public mounted() {
      axios
        .post('/-/trade/api/widgets.growthCustomers')
        .then(({data}) => {
          this.source = data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dialog :deep {
    padding: 0;
  }

  .dialog :deep(.dean-dialog-container) {
    width: 100%;
    height: 100%;
  }

  .dialog :deep(.dean-dialog-container) :deep(.dean-dialog-content) {
    height: 100%;
  }
</style>
